module.exports = __webpack_public_path__ + "img/max-file-edit--zip.be4d8520.svg";